<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			<el-breadcrumb-item>自营订单</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="订单号">
				<el-input v-model="item.order_sn" placeholder="请输入订单号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="item.order_status" placeholder="请选择状态" size="small">
					<el-option label="待付款" value="1"></el-option>
					<el-option label="待发货" value="2"></el-option>
					<el-option label="待收货" value="3"></el-option>
					<el-option label="已完成" value="4"></el-option>
					<el-option label="用户取消" value="5"></el-option>
					<el-option label="系统取消" value="6"></el-option>
					<el-option label="退货退款" value="7"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<div class="list-box" :data="list">
			<div class="list-box-title">
				<span>商品</span>
				<span>所属</span>
				<span>买家</span>
				<span>收货信息</span>
				<span>支付/配送</span>
				<span>实付款</span>
				<span>操作</span>
				<span>状态</span>
			</div>
			<div class="list-box-content">
				<div class="list" v-for="list in list">
					<div class="list-title">
						<span>{{list.created_date}}</span>
						<span>订单编号：{{list.order_sn}}</span>
					</div>
					<div class="list-content-box">
						<div class="list-content">
							<div class="different-box">
								<div class="different" v-for="attr in list.goods">
									<div class="thumb">
										<img :src="attr.pic_url" width="70px" height="70px" style="height: 70px">
										<div class="goods-text">
											<span>{{attr.product_name}}</span>
											<span>{{attr.sku_name}}</span>
										</div>
									</div>
									<div>
										<span>￥{{attr.price}} </span>
										<span>&nbsp;x&nbsp;{{attr.number}}</span>
									</div>
									<div>
<!--										<span v-if="attr.supplierName">{{attr.supplierName}}</span>-->
<!--										<span v-else>{{attr.storeName}}</span>-->
									</div>
								</div>
								<div class="different" v-for="attr in list.gives">
									<div class="thumb">
										<img :src="attr.pic_url" width="70px" height="70px" style="height: 70px">
										<div class="goods-text">
											<span>{{attr.product_name}}</span>
											<span>{{attr.sku_name}}</span>
										</div>
									</div>
									<div>
										<span>&nbsp;x&nbsp;{{attr.number}}</span>
									</div>
									<div>
										<span style="color: red">赠品</span>
									</div>
								</div>
							</div>
							<div>
								<span>{{list.buyer ? list.buyer.nick_name : ''}}</span>
								<span>{{list.buyer ? list.buyer.mobile : ''}}</span>
							</div>
							<div>
								<p>收货人：<span class="color-blue">{{list.consignee}}</span></p>
								<p>买家手机：<span>{{list.mobile}}</span>
								<p>收货地址：<span class="color-blue">{{list.address}}</span>
								</p>
							</div>
							<div>
								<span> {{list.pay_type == 1 ? '微信支付' : '积分支付'}}</span>
							</div>
							<div>
								<span>￥{{list.actual_price}}</span>
							</div>
							<div>
								<span class="list-booton-edit clike-cursor" @click="edit(list.id)">查看详情</span>
<!--								<span class="list-booton-edit">物流信息</span>-->
								<el-button size="mini" type="default" @click="open(list)" v-if="list.order_status == 2 && list.supplier_id == 0">
									发货
								</el-button>
							</div>
							<div>
								<span v-if="list.order_status == 1">待付款</span>
								<span v-else-if="list.order_status == 2">待发货</span>
								<span v-else-if="list.order_status == 3">待收货</span>
								<span v-else-if="list.order_status == 4">已完成</span>
								<span v-else-if="list.order_status == 5">用户取消</span>
								<span v-else-if="list.order_status == 6">系统取消</span>
								<el-tag size="small" type="info" effect="dark" v-else-if="item.order_status == 21">退款申请中
								</el-tag>
								<span v-else></span>
							</div>
						</div>
					</div>
					<div class="list-booton">
						<!-- <span>1级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span>2级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span class="list-booton-edit">修改佣金 </span> -->
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="订单发货" :visible.sync="dialogFormVisible">
			<el-form label-position="right" :model="form" label-width="auto">
				<el-form-item label="收货人" v-if="order">
					{{order.consignee}}
				</el-form-item>
				<el-form-item label="买家手机"  v-if="order">
					{{order.mobile}}
				</el-form-item>
				<el-form-item label="收货地址"  v-if="order">
					{{order.address}}
				</el-form-item>
				<el-form-item label="物流公司">
					<el-select v-model="form.express_id" clearable placeholder="请选择物流公司">
						<el-option v-for="item in express" :value="item.id" :label="item.express_name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="物流单号">
					<el-input clearable v-model="form.express_sn" placeholder="请输入物流单号"/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="send" v-auth="['store/order/sendShip']">发货</el-button>
			</div>
		</el-dialog>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				express: [],
				form: {},
				dialogFormVisible: false,
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				order: false
			}
		},
		created() {
			this.loadData()
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadList()
		},
		methods: {
			open(order) {
				this.isLoad = !this.isLoad
				this.axios.get('/channelv1/order/detail', {
					params: {
						id: order.id
					}
				}).then(res => {
					this.isLoad = !this.isLoad
					this.form = {
						id: order.id,
						goods: res.data.detail.goods
					}
					this.order = res.data.detail
					this.dialogFormVisible = true
				})
			},
			loadData() {
				this.axios.post('/channelv1/data/listLogisticsForSelect').then(res => {
					this.express = res.data.list
				}).catch(() => {
				})
			},
			async send() {
				// this.isLoad = !this.isLoad
				let res = ''
				try {
					var _this = this
					this.axios.post('/channelv1/order/sendShip', {
						id: this.form.id,
						form: {
							express_id: this.form.express_id,
							express_company: this.form.express_id ? (this.express.find(function (item) {
								return _this.form.express_id == item.id
							})).express_name : '',
							express_sn: this.form.express_sn
						}
					}).then(res => {
						this.isLoad = false
						this.$message.success({
							message: '发货成功'
						});
						this.dialogFormVisible = false
						this.loadList()
					}) .catch((e) => {
						this.isLoad = false
					})
				} catch (res) {
				}

			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''

				res = await this.axios.post('/channelv1/order/selfOrder', this.item)
				this.list = res.data.list.data
				this.total = res.data.list.total

				this.isLoad = !this.isLoad
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Indent/list.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				if(this.item.sourceId){
					this.item.sourceId = this.item.sourceId[this.item.sourceId.length-1]
				}
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
		}
	}
</script>
<style scoped>
	.list-box {
		width: 100%;
		background-color: #FFF;
	}

	.list-box .list-box-title {
		width: 100%;
		height: 50px;
		background-color: #f8f8f8;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		margin-bottom: 30px;
	}

	.list-box-title span {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
	}

	.list-box-title span:first-child {
		flex-grow: 2;
		justify-content: space-between;
		text-indent: 40px;
	}

	.list-box .list-box-content {
		width: 100%;
		border: 1px solid #e5e5e5;
	}

	.list-box-content .list {
		width: 100%;
	}

	.list .list-title {
		width: 100%;
		height: 64px;
		background-color: #f7f7f7;
		padding-left: 30px;
		box-sizing: border-box;
		line-height: 64px;
		color: #9f8e8e;
	}

	.list-title span:first-child {
		font-weight: bold;
		margin-right: 20px;
		color: black;
	}

	.list .list-content-box {
		border-bottom: 1px solid #e5e5e5;
		margin: 0 20px;
	}

	.list-content-box .list-content {
		display: flex;
		flex-wrap: nowrap;
	}


	.list-content span {
		line-height: 1.5;
	}

	.list-content .different-box {
		flex-grow: 3;
		border-left: none !important;
	}

	.different-box .different {
		width: 100%;
		height: 120px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
	}

	.different>div {
		display: flex;
		width: 1px;
		flex-grow: 1;
		justify-content: center;
	}

	.different .thumb {
		display: flex;
		flex-direction: row !important;
		align-items: center;
	}

	.different .goods-text {
		display: flex;
		flex-direction: column;
		margin-left: 20px;
	}

	.text-line {
		line-height: 50px !important;
	}

	.list-content>div {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-left: 1px solid #e5e5e5;
	}

	.list .list-booton {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.list-booton span {
		font-weight: 600;
	}

	.list-booton-edit {
		color: #0027e3;
		cursor: pointer;
	}
</style>
